import { render, staticRenderFns } from "./merchantProduct.vue?vue&type=template&id=3ca5df0c&scoped=true&"
import script from "./merchantProduct.vue?vue&type=script&lang=ts&"
export * from "./merchantProduct.vue?vue&type=script&lang=ts&"
import style0 from "./merchantProduct.vue?vue&type=style&index=0&id=3ca5df0c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ca5df0c",
  null
  
)

export default component.exports